import { Component, OnInit } from '@angular/core';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
// Servicio
import { ClientesService } from '../../../services/Clientes.service';
import { EmpleadosServicio } from '../../../services/empleado.service';
import { PrestamosService } from '../../../services/prestamos.service';

// use jquery
declare var $: any;

// Helpers
import { Helper } from '../../../helpers/helper';

// Modal
import { AlertasModales } from '../../../helpers/alertasModales';
import { Router } from '@angular/router';
import { DecimalPipe } from '@angular/common';
import {config} from "exceljs";
import {constructDependencies} from "@angular/core/src/di/reflective_provider";

@Component({
  selector: 'app-nuevo',
  templateUrl: './nuevo.component.html',
  styleUrls: ['./nuevo.component.css']
})
export class NuevoPrestamoComponent implements OnInit {
  form: FormGroup;
  cedulas: Observable<Array<any>>;
  prestamo: any = {
    tazaInteres: null,
    tipoInteres: null,
    moraPorciento: null,
    plazo: null,
    tipoPlazo: null,
    plazoEnDias: null,
    formaPago: null,
    diasExcluir: null,
    gastoCierre: null,
    tipoGastoCierre: null,
    tipoGastoCierreR: null
  };
  tablaAmortizacion: Array<any> = [];
  montoIncremento = 1;
  montoIncrementoR = 1;
  fechaPrestamo: NgbDateStruct;
  fechaInicia: NgbDateStruct;
  otraFormaPago = false;
  prestamoFormaPago: string;
  loading = false;
  isRenovacion = false;
  configuraciones: any;
  msgsRequiereAprobacion = [];
  requiere_aprobacion = false;
  gasto: any;
  gastoR: any;
  private requiere_aprobacion_monto = 0;
  private minimo_cuota_renovacion = 0;
  private minimo_cuotas_atraso = 0;
  private porciento_renovar = 0;
  private ultimo_p = {
    cuota_actual: 0,
    cuotas_atraso: 0
  };
  constructor(public _prestamo: PrestamosService,
    public CS: ClientesService,
    private helper: Helper,
    private modals: AlertasModales,
    private route: Router,
    private empleadoService: EmpleadosServicio) {

    this.initConfiguracion();
  }

  ngOnInit() {
    this.initPrestamo();
    // Asignar ID del empleado al formulario
    if (localStorage.getItem('nuevoCliente')) {
      this.clientePorCedula(localStorage.getItem('nuevoCliente'));
      localStorage.removeItem('nuevoCliente');
    }
    this.form.get('ID_EMPLEADO').setValue(this.empleadoService.datosEmpleado.ID_EMPLEADO);

  }

  // Cargar datos cliente por su cedula
  private clientePorCedula(ID): void {
    this.CS.obtenerClientePorID(ID).subscribe((res: any) => {
      this.form.get('cedulaCliente').setValue(res.cedula);
      this.form.get('nombreCliente').setValue(`${res.nombre} ${res.apellido}`);
      this.form.get('nombreComercial').setValue(res.apodo);
      this.form.get('telefono').setValue(res.telefono);
      this.form.get('ID_CLIENTE').setValue(res.ID_CLIENTE);
      this.form.get('rutaNombre').setValue(res.ruta_nombre);
      this.form.get('rutaID').setValue(res.ID_RUTA);
      this.form.get('requiere_aprobacion').setValue(res.requiere_aprobacion);
      this.form.get('requiere_aprobacion_monto').setValue(res.requiere_aprobacion_monto);
    });
  }

  private initPrestamo(): void {

    this.fechaPrestamo = {
      year: parseFloat(this.helper.getMoment().format('YYYY')),
      month: parseFloat(this.helper.getMoment().format('MM')),
      day: parseFloat(this.helper.getMoment().format('DD'))
    };

    this.cedulasInit();

    // Inicializar formulario para cliente
    this.form = new FormGroup({
      'cedulaCliente': new FormControl({ value: '', disabled: true }),
      'nombreCliente': new FormControl({ value: '', disabled: true }),
      'nombreComercial': new FormControl({ value: '', disabled: true }),
      'telefono': new FormControl({ value: '', disabled: true }),
      'ID_CLIENTE': new FormControl(''),
      'ID_EMPLEADO': new FormControl(''),
      'rutaNombre': new FormControl(''),
      'rutaID': new FormControl('', Validators.required),
      'fechaPrestamo': new FormControl(''),
      'fechaInicia': new FormControl(''),
      'fechaVence': new FormControl(''),
      'requiere_aprobacion': new FormControl(''),
    });

    const data = {
      tipo: this.prestamo.tipoGastoCierre,
      monto_gasto_cierre: this.prestamo.gastoCierre,
      capital_prestamo: this.prestamo.capital,
      monto_incremento: this.montoIncremento
    };
    this.prestamo.gastoCierre = this._prestamo.calcularGastoCierre(data);

  }

  // Inicializar la variable cedulas
  cedulasInit() {
    this.cedulas = this._prestamo.obtenerRncClientes();
  }

  formChange() {
    if (parseFloat(this.prestamo.capital) > 0) {
      this.msgsRequiereAprobacion = [];
      const numberPipe = new DecimalPipe('en-US');
      if (!this.isRenovacion) {
        if (parseFloat(this.prestamo.capital) > this.requiere_aprobacion_monto && this.form.get('requiere_aprobacion').value === 1) {
          this.requiere_aprobacion = true;
        }
      } else {

        if (this.ultimo_p.cuota_actual < this.minimo_cuota_renovacion) {
          this.msgsRequiereAprobacion
            // tslint:disable-next-line:max-line-length
            .push(`El préstamo de este cliente va por la cuota ${this.ultimo_p.cuota_actual}, el mínimo a renovar es de ${this.minimo_cuota_renovacion}`);
        }
        if (parseFloat(this.prestamo.capital) > this.requiere_aprobacion_monto) {
          this.msgsRequiereAprobacion
            .push(`El monto máximo para esta renovación es de ${numberPipe.transform(this.requiere_aprobacion_monto, '1.0-2')}`);
        }
        if (this.ultimo_p.cuotas_atraso > this.minimo_cuotas_atraso) {
          this.msgsRequiereAprobacion
            // tslint:disable-next-line:max-line-length
            .push(`El préstamo de este cliente tiene ${this.ultimo_p.cuotas_atraso} cuota${this.ultimo_p.cuotas_atraso > 1 ? 's' : ''} en atraso, el mínimo es de ${this.minimo_cuotas_atraso}`);
        }
        if (
          this.ultimo_p.cuota_actual < this.minimo_cuota_renovacion ||
          parseFloat(this.prestamo.capital) > this.requiere_aprobacion_monto ||
          this.ultimo_p.cuotas_atraso > this.minimo_cuotas_atraso
        ) {
          this.requiere_aprobacion = true;
        } else {
          this.requiere_aprobacion = false;
        }
      }

      const formaPago = (this.otraFormaPago && this.prestamoFormaPago ? this.prestamoFormaPago : this.prestamo.formaPago);



      let saldoP = parseFloat(this.prestamo.montoTotal);
      this.tablaAmortizacion = [];
      const { year, month, day } = this.fechaInicia;
      const fechaInicia = this.helper.getMoment(`${year}-${month}-${day}`);


      if (this.prestamo.tipoInteres === 'Lineal') {
        // Plazo en dias
        this.prestamo.plazoEnDias = parseFloat(this.prestamo.plazo) * parseFloat(this.prestamo.tipoPlazo);

        // total de cuotas
        this.prestamo.totalCuotas = Math.ceil(parseFloat(this.prestamo.plazoEnDias) / parseFloat(formaPago)),

          // interes acomulado
          this.prestamo.interesAcomulado = parseFloat(this.prestamo.plazoEnDias) / 30 *
          parseFloat((this.prestamo.tazaInteres ? this.prestamo.tazaInteres : 0));

        // total interes
        this.prestamo.totalInteres = Math.ceil(parseFloat(this.prestamo.interesAcomulado) / 100 * parseFloat(this.prestamo.capital));

        // monto cuotas
        this.prestamo.montoCuotas = (parseFloat(this.prestamo.capital) +
          parseFloat(this.prestamo.totalInteres)) /
          parseFloat(this.prestamo.totalCuotas);

        // Monto total
        this.prestamo.montoTotal = Math.ceil(parseFloat(this.prestamo.totalCuotas) * parseFloat(this.prestamo.montoCuotas));
        for (let i = 1; i <= this.prestamo.totalCuotas; i++) {
          if (parseFloat(formaPago) !== 30) {
            if (this.configuraciones.diasExcluir === 2) { // Excluir domingo
              fechaInicia.add((fechaInicia.day() === 0 ? 1 : 0), 'day');
            } else if (this.configuraciones.diasExcluir === 3) { // Excluir sabado y domingo

              fechaInicia.add(
                (fechaInicia.day() === 6 ? 2 : (fechaInicia.day() === 0 ? 1 : 0)),
                'day'
              );
            }
          }

          saldoP -= parseFloat(this.prestamo.montoCuotas);

          this.tablaAmortizacion.push({
            numero_cuota: i,
            fechaVence: fechaInicia.format(),
            capital: parseFloat(this.prestamo.capital) / parseFloat(this.prestamo.totalCuotas),
            interes: parseFloat(this.prestamo.totalInteres) / parseFloat(this.prestamo.totalCuotas),
            montoCuotas: Math.ceil(this.prestamo.montoCuotas),
            saldoPrestamo: (i !== parseFloat(this.prestamo.totalCuotas)) ? Math.ceil(saldoP) : 0
          });

          if (parseFloat(formaPago) === 30) {
            fechaInicia.add(1, 'month');

          } else {
            if (this.configuraciones.diasExcluir === 2) { // Excluir domingo
              fechaInicia.add(parseFloat(formaPago) + (fechaInicia.day() === 0 ? 1 : 0), 'day');
            } else if (this.configuraciones.diasExcluir === 3) { // Excluir sabado y domingo

              fechaInicia.add(
                parseFloat(formaPago) + (fechaInicia.day() === 6 ? 2 : (fechaInicia.day() === 0 ? 1 : 0)),
                'day'
              );

            } else {
              fechaInicia.add(parseFloat(formaPago), 'day');
            }
          }
        }
      }
      if (this.prestamo.tipoInteres === 'Simple') {
        // Plazo en dias
        this.prestamo.plazoEnDias = parseFloat(this.prestamo.plazo) * parseFloat(this.prestamo.tipoPlazo);

        // total de cuotas
        this.prestamo.totalCuotas = Math.ceil(parseFloat(this.prestamo.plazoEnDias) / parseFloat(formaPago));

        // interes acomulado
        this.prestamo.interesAcomulado = parseFloat(this.prestamo.plazoEnDias) / 30 *
          parseFloat((this.prestamo.tazaInteres ? this.prestamo.tazaInteres : 0));
        // interes de una cuota
        let interes = (this.prestamo.capital * this.prestamo.tazaInteres) / 100, interesAux;
        interes += this.prestamo.interesAcomulado;
        // tslint:disable-next-line:comment-format
        //para calcular el saldo del prestamo
        interesAux = interes;
        const monto = this.prestamo.capital / this.prestamo.totalCuotas;
        // tslint:disable-next-line:comment-format
        //monto cuotas
        this.prestamo.montoCuotas = (monto + interes) - this.prestamo.interesAcomulado;
        this.prestamo.montoTotal = this.prestamo.capital;
        let saldoPrestamo = parseFloat(this.prestamo.montoTotal);
        for (let i = 1; i <= this.prestamo.totalCuotas; i++) {
          interesAux -= this.prestamo.interesAcomulado;
          saldoPrestamo += interesAux;
        }
        for (let i = 1; i <= this.prestamo.totalCuotas; i++) {
          if (parseFloat(formaPago) !== 30) {
            if (this.configuraciones.diasExcluir === 2) { // Excluir domingo
              fechaInicia.add((fechaInicia.day() === 0 ? 1 : 0), 'day');
            } else if (this.configuraciones.diasExcluir === 3) { // Excluir sabado y domingo

              fechaInicia.add(
                (fechaInicia.day() === 6 ? 2 : (fechaInicia.day() === 0 ? 1 : 0)),
                'day'
              );
            }
          }


          interes -= this.prestamo.interesAcomulado;
          saldoPrestamo -= monto + interes;
          // total interes
          this.prestamo.totalInteres += interes;
          // Monto total
          this.prestamo.montoTotal += interes;

          this.tablaAmortizacion.push({
            numero_cuota: i,
            fechaVence: fechaInicia.format(),
            capital: parseFloat(this.prestamo.capital) / parseFloat(this.prestamo.totalCuotas),
            interes: interes,
            montoCuotas: monto + interes,
            saldoPrestamo: (i === parseFloat(this.prestamo.totalCuotas)) ? 0 : Math.ceil(saldoPrestamo)
          });

          if (parseFloat(formaPago) === 30) {
            fechaInicia.add(1, 'month');

          } else {
            if (this.configuraciones.diasExcluir === 2) { // Excluir domingo
              fechaInicia.add(parseFloat(formaPago) + (fechaInicia.day() === 0 ? 1 : 0), 'day');
            } else if (this.configuraciones.diasExcluir === 3) { // Excluir sabado y domingo

              fechaInicia.add(
                parseFloat(formaPago) + (fechaInicia.day() === 6 ? 2 : (fechaInicia.day() === 0 ? 1 : 0)),
                'day'
              );

            } else {
              fechaInicia.add(parseFloat(formaPago), 'day');
            }
          }
        }
      }
      if (this.prestamo.tipoInteres === 'Bancario') {
        // Plazo en dias
        this.prestamo.plazoEnDias = parseFloat(this.prestamo.plazo) * parseFloat(this.prestamo.tipoPlazo);

        // total de cuotas
        this.prestamo.totalCuotas = Math.ceil(parseFloat(this.prestamo.plazoEnDias) / parseFloat(formaPago)),

          // interes acomulado
          this.prestamo.interesAcomulado = parseFloat(this.prestamo.plazoEnDias) / 30 *
          parseFloat((this.prestamo.tazaInteres ? this.prestamo.tazaInteres : 0));

        // total interes
        this.prestamo.totalInteres = 0;



        // Monto total
        this.prestamo.montoTotal = 0;

        let saldoPrestamo = parseFloat(this.prestamo.montoTotal);
        let num = (1 + (this.prestamo.tazaInteres / 100));
        num = Math.pow(num, this.prestamo.plazo);
        num *= (this.prestamo.tazaInteres / 100);
        let denom = (1 + (this.prestamo.tazaInteres / 100));
        denom = Math.pow(denom, this.prestamo.plazo);
        denom -= 1;
        const pago = this.prestamo.capital * (num / denom);
        let balance = this.prestamo.capital, interes = (this.prestamo.tazaInteres / 100) * this.prestamo.capital;
        let interesAux = interes;
        for (let i = 1; i <= this.prestamo.totalCuotas; i++) {
          interesAux -= this.prestamo.interesAcomulado;
          saldoPrestamo += interesAux;
        }
        interesAux = interes;
        let capitalCuota = 0;
        // tslint:disable-next-line:comment-format
        //monto cuotas
        this.prestamo.montoCuotas = ((pago - interes) + interesAux);
        for (let i = 1; i <= this.prestamo.plazo; i++) {
          if (parseFloat(formaPago) !== 30) {
            if (this.configuraciones.diasExcluir === 2) { // Excluir domingo
              fechaInicia.add((fechaInicia.day() === 0 ? 1 : 0), 'day');
            } else if (this.configuraciones.diasExcluir === 3) { // Excluir sabado y domingo

              fechaInicia.add(
                (fechaInicia.day() === 6 ? 2 : (fechaInicia.day() === 0 ? 1 : 0)),
                'day'
              );
            }
          }
          capitalCuota = pago - interes;

          this.tablaAmortizacion.push({
            numero_cuota: i,
            fechaVence: fechaInicia.format(),
            capital: Math.ceil(capitalCuota),
            interes: Math.ceil(interes),
            montoCuotas: Math.ceil(capitalCuota + interes),
            saldoPrestamo: (i === parseFloat(this.prestamo.totalCuotas)) ? 0 : Math.ceil(saldoPrestamo)
          });
          // total interes
          this.prestamo.totalInteres += Math.ceil(interes);
          // Monto total
          this.prestamo.montoTotal += Math.ceil(interes);
          balance -= capitalCuota;
          interes = (this.prestamo.tazaInteres / 100) * balance;

          if (parseFloat(formaPago) === 30) {
            fechaInicia.add(1, 'month');

          } else {
            if (this.configuraciones.diasExcluir === 2) { // Excluir domingo
              fechaInicia.add(parseFloat(formaPago) + (fechaInicia.day() === 0 ? 1 : 0), 'day');
            } else if (this.configuraciones.diasExcluir === 3) { // Excluir sabado y domingo

              fechaInicia.add(
                parseFloat(formaPago) + (fechaInicia.day() === 6 ? 2 : (fechaInicia.day() === 0 ? 1 : 0)),
                'day'
              );

            } else {
              fechaInicia.add(parseFloat(formaPago), 'day');
            }
          }
        }
        this.prestamo.montoTotal += this.prestamo.capital;



      }
      if (this.prestamo.tipoInteres === 'Solo interes') {
        // Plazo en dias
        this.prestamo.plazoEnDias = parseFloat(this.prestamo.plazo) * parseFloat(this.prestamo.tipoPlazo);

        // total de cuotas
        this.prestamo.totalCuotas = this.prestamo.plazo;

        // interes acomulado
        this.prestamo.interesAcomulado = parseFloat(this.prestamo.plazoEnDias) / 30 *
          parseFloat((this.prestamo.tazaInteres ? this.prestamo.tazaInteres : 0));

        // total interes
        this.prestamo.totalInteres = 0;



        let saldoPrestamo = 0;
        const interes = Math.ceil((this.prestamo.tazaInteres / 100) * this.prestamo.capital);
        // Monto total
        this.prestamo.montoTotal = this.prestamo.capital + interes;
        this.prestamo.totalInteres = interes;
        for (let i = 1; i <= this.prestamo.plazo; i++) {
          if (parseFloat(formaPago) !== 30) {
            if (this.configuraciones.diasExcluir === 2) { // Excluir domingo
              fechaInicia.add((fechaInicia.day() === 0 ? 1 : 0), 'day');
            } else if (this.configuraciones.diasExcluir === 3) { // Excluir sabado y domingo

              fechaInicia.add(
                (fechaInicia.day() === 6 ? 2 : (fechaInicia.day() === 0 ? 1 : 0)),
                'day'
              );
            }
          }

          if (i === this.prestamo.plazo) {
            saldoPrestamo = interes + this.prestamo.capital;

          }
          this.tablaAmortizacion.push({
            numero_cuota: i,
            fechaVence: fechaInicia.format(),
            capital: Math.ceil(i === this.prestamo.plazo ? this.prestamo.capital : 0),
            interes: Math.ceil(interes),
            montoCuotas: Math.ceil((i === this.prestamo.plazo ? this.prestamo.capital : 0) + interes),
            saldoPrestamo: (i === parseFloat(this.prestamo.totalCuotas)) ? 0 : Math.ceil(saldoPrestamo)
          });
          // total interes
          this.prestamo.totalInteres += Math.ceil(interes);
          // Monto total
          this.prestamo.montoTotal += Math.ceil(interes);

          // monto cuotas
          this.prestamo.montoCuotas = this.prestamo.capital + interes;


          if (parseFloat(formaPago) === 30) {
            fechaInicia.add(1, 'month');

          } else {
            if (this.configuraciones.diasExcluir === 2) { // Excluir domingo
              fechaInicia.add(parseFloat(formaPago) + (fechaInicia.day() === 0 ? 1 : 0), 'day');
            } else if (this.configuraciones.diasExcluir === 3) { // Excluir sabado y domingo

              fechaInicia.add(
                parseFloat(formaPago) + (fechaInicia.day() === 6 ? 2 : (fechaInicia.day() === 0 ? 1 : 0)),
                'day'
              );

            } else {
              fechaInicia.add(parseFloat(formaPago), 'day');
            }
          }
        }


      }
      if (this.prestamo.tipoInteres === 'Solo capital') {
        // Plazo en dias
        this.prestamo.plazoEnDias = parseFloat(this.prestamo.plazo) * parseFloat(this.prestamo.tipoPlazo);

        // total de cuotas
        this.prestamo.totalCuotas = 1;

        // interes acomulado
        this.prestamo.interesAcomulado = parseFloat(this.prestamo.plazoEnDias) / 30 *
          parseFloat((this.prestamo.tazaInteres ? this.prestamo.tazaInteres : 0));


        const interes = (this.prestamo.tazaInteres / 100) * this.prestamo.capital;
        // total interes
        this.prestamo.totalInteres = interes;

        this.tablaAmortizacion.push({
          numero_cuota: 1,
          fechaVence: fechaInicia.format(),
          capital: Math.ceil(this.prestamo.capital),
          interes: Math.ceil(interes),
          montoCuotas: Math.ceil(this.prestamo.capital + interes),
          saldoPrestamo: 0
        });
        // monto cuotas
        this.prestamo.montoCuotas = this.prestamo.capital + interes;
        // tslint:disable-next-line:comment-format
        //total prestado
        this.prestamo.montoTotal = this.prestamo.capital + interes;
      }

    } else {
      this.tablaAmortizacion = [];
      // this.prestamo.capital = '';
      this.prestamo.totalInteres = 0;
      this.prestamo.montoCuotas = 0;
      this.prestamo.montoTotal = 0;
    }

    if (this.isRenovacion) {
      const data = {
        tipo: this.prestamo.tipoGastoCierreR,
        monto_gasto_cierre: this.gastoR,
        capital_prestamo: this.prestamo.capital,
        monto_incremento: this.montoIncrementoR
      };
      this.prestamo.gastoCierre = this._prestamo.calcularGastoCierre(data);
    } else {
      const data = {
        tipo: this.prestamo.tipoGastoCierre,
        monto_gasto_cierre: this.gasto,
        capital_prestamo: this.prestamo.capital,
        monto_incremento: this.montoIncremento
      };
      this.prestamo.gastoCierre = this._prestamo.calcularGastoCierre(data);

    }


  }


  cambiarFechaTermina() {

    const fechaInicia = new Date(this.fechaPrestamo.year, this.fechaPrestamo.month - 1, this.fechaPrestamo.day);
    fechaInicia.setDate(fechaInicia.getDate() + parseFloat(this.prestamo.formaPago));
    this.fechaInicia = { year: fechaInicia.getFullYear(), month: fechaInicia.getMonth() + 1, day: fechaInicia.getDate() };

    this.formChange();
  }


  busquedaAvanzada() {
    this.modals.busquedaAvanzadaClientesNgbModal().then((res: any) => {
      if (res) {
        this.form.get('cedulaCliente').setValue(res.cedula);
        this.form.get('nombreCliente').setValue(res.nombre + ' ' + res.apellido);
        this.form.get('nombreComercial').setValue(res.apodo);
        this.form.get('telefono').setValue(res.telefono);
        this.form.get('rutaNombre').setValue(res.ruta_nombre);
        this.form.get('rutaID').setValue(res.ID_RUTA);
        this.form.get('ID_CLIENTE').setValue(res.id);
        this.form.get('requiere_aprobacion').setValue(res.requiere_aprobacion);
        this.requiere_aprobacion_monto = res.requiere_aprobacion_monto;

        if (!res.puede_renovar || res.fallecido) {
          this.modals.validacionesModalJquery('La renovación para este cliente está bloqueada', 'No le puedes renovar a este cliente',
            'red',
            'modern',
            false,
            'fa fa-ban');
          this.route.navigate(['/inicio']);
          return;
        }

        this.revisaPrestamoActivos();
        this.initConfiguracion(res.ID_RUTA);
      }
    });
  }

  resetClienteForm() {
    const cedula = this.form.get('cedulaCliente').value;
    this.form.reset({ ID_EMPLEADO: this.empleadoService.datosEmpleado.ID_EMPLEADO });
    this.form.get('cedulaCliente').setValue(cedula);
  }

  revisaPrestamoActivos() {
    const cedCliente = this.form.get('cedulaCliente').value;
    // =================== REVISA SI EL CLIENTE EXISTE ===================
    this.CS.revisarSiClienteExisteRegistradoDB(cedCliente).subscribe((cliente_exist: any) => {
      if (!cliente_exist) {
        this.modals.errorClienteNoExiste(this.route,
          'CLIENTE NO ENCONTRADO',
          `El cliente con la cédula <strong>${cedCliente}</strong> no existe`,
          'Registrar cliente',
          'red'
        );
      }
    });

    this._prestamo.obtenerListaPrestamosCliente(this.form.get('ID_CLIENTE').value)
      .subscribe((res: Array<any>) => {
        if (res.length) {
          this.isRenovacion = true;
          this.ultimo_p.cuota_actual = res[0].cuota_actual;
          this.ultimo_p.cuotas_atraso = res[0].cuotas_atraso;
          this.requiere_aprobacion_monto = res[0].capital + (res[0].capital * this.porciento_renovar) / 100;

          res = res.filter(item => item.estado !== 3);
          let prestamoDetalleActivos = `
          <p>&nbsp;</p>
          <table class="table table-striped">
            <thead>
              <tr>
                <td>Préstamo No.</td>
                <td>Capital</td>
                <td>Fecha Préstamo</td>
              </tr>
            </thead>
            <tbody>`;

          for (const item of res) {
            let prestamoFecha = item.fecha_prestamo.split('T')[0];
            prestamoFecha = prestamoFecha.split('-')[2] + '/' + prestamoFecha.split('-')[1] + '/' + prestamoFecha.split('-')[0];
            prestamoDetalleActivos += `
              <tr>
                <td>${item.ID_PRESTAMO}</td>
                <td>${Number(item.capital)}</td>
                <td>${prestamoFecha}</td>
              </tr>`;
          }
          prestamoDetalleActivos += `</tbody></table>`;
          if (res.length) {
            this.modals.correctoModalJquery(
              'ADVERTENCIA',
              'orange',
              'modern',
              'fa fa-warning',
              `EL CLIENTE YA CUENTA CON UNO O VARIOS PRÉSTAMOS PENDIENTE DE SALDO.<br />
              ${prestamoDetalleActivos}`
            );
          }
        }
      });

  }

  registrarPrestamo() {

    // Verificar si cliente tiene prestamo activos

    if (this.form.valid && this.tablaAmortizacion.length > 0) {
      this.loading = true;
      const fechaPrestamo = new Date(this.fechaPrestamo.year,
        this.fechaPrestamo.month - 1,
        this.fechaPrestamo.day).toString().split('GMT')[0];

      const fechaInicia = new Date(this.fechaInicia.year,
        this.fechaInicia.month - 1,
        this.fechaInicia.day).toString().split('GMT')[0];
      this.prestamo.formaPago = (this.otraFormaPago && this.prestamoFormaPago ? this.prestamoFormaPago : this.prestamo.formaPago);
      this.form.get('requiere_aprobacion').setValue(this.requiere_aprobacion);
      this.form.get('fechaPrestamo').setValue(fechaPrestamo);
      this.form.get('fechaInicia').setValue(fechaInicia);
      this.form.get('fechaVence').setValue(this.tablaAmortizacion[this.tablaAmortizacion.length - 1].fechaVence);
      this._prestamo.registrarNuevoPrestamo(this.form.value, this.prestamo, this.tablaAmortizacion)
        .subscribe(res => {
          this.loading = false;
          if (res) {
            const IDS = {
              PRESTAMO: res.ID,
              CLIENTE: res.ID_C
            };
            if (res.estado === 0) {
              this.modals.irAModalJquery(
                this.route,
                IDS,
                'prestamo',
                'Préstamo registrado con éxito',
                'Su préstamo ha sido creado y se encuentra en revisión.',
                'VER PRÉSTAMO',
                'green',
                'modern',
                'btn-green',
                'fa fa-usd fa-fw'
              );

            } else {

              this.modals.irAModalJquery(
                this.route,
                IDS,
                'prestamo',
                'Préstamo registrado con éxito',
                '',
                'VER PRÉSTAMO',
                'green',
                'modern',
                'btn-green',
                'fa fa-usd fa-fw'
              );
            }
            this.resetForm();
          }
        }, (err) => {
          this.loading = false;
          if (err) {
            this.modals.validacionesModalJquery('Error', err.error, 'red');
          }
        });
    }
  }

  resetForm() {
    this.form.reset({ ID_EMPLEADO: this.empleadoService.datosEmpleado.ID_EMPLEADO });
    this.tablaAmortizacion = [];
    this.otraFormaPago = false;
    this.requiere_aprobacion = false;
    this.isRenovacion = false;
    this.prestamoFormaPago = '';
  }

  private initConfiguracion(ID_RUTA = 0): void {
    this._prestamo.obtenerConfiguracionPrestamo(ID_RUTA)
      .subscribe((res: any) => {
        this.configuraciones = res;
        this.prestamo.tazaInteres = this.configuraciones.tazaInteres;
        this.prestamo.tipoInteres = this.configuraciones.tipoInteres;
        this.prestamo.moraPorciento = this.configuraciones.moraPorciento;
        this.prestamo.plazo = this.configuraciones.plazo;
        this.prestamo.tipoPlazo = this.configuraciones.tipoPlazo;
        this.prestamo.plazoEnDias = this.configuraciones.plazoEnDias;
        this.prestamo.formaPago = String(this.configuraciones.formaPago);
        this.prestamo.diasExcluir = String(this.configuraciones.diasExcluir);
        this.gasto = this.configuraciones.pn_monto_gasto_cierre;
        this.prestamo.tipoGastoCierre = this.configuraciones.pn_tipo_gasto_cierre;
        this.montoIncremento = this.configuraciones.pn_monto_incremento;

        this.gastoR = this.configuraciones.r_monto_gasto_cierre;
        this.prestamo.tipoGastoCierreR = this.configuraciones.r_tipo_gasto_cierre;
        this.montoIncrementoR = this.configuraciones.r_monto_incremento;

        const { year, month, day } = this.fechaPrestamo;

        this.fechaInicia = {
          year: parseFloat(this.helper.getMoment(`${year}-${month}-${day}`).add(this.configuraciones.formaPago, 'day').format('YYYY')),
          month: parseFloat(this.helper.getMoment(`${year}-${month}-${day}`).add(this.configuraciones.formaPago, 'day').format('MM')),
          day: parseFloat(this.helper.getMoment(`${year}-${month}-${day}`).add(this.configuraciones.formaPago, 'day').format('DD'))
        };

        this.minimo_cuota_renovacion = this.configuraciones.minimo_cuota_renovacion;
        this.minimo_cuotas_atraso = this.configuraciones.minimo_cuotas_atraso;
        this.porciento_renovar = this.configuraciones.porciento_renovar;
        const data = {
          tipo: this.prestamo.tipoGastoCierre,
          monto_gasto_cierre: this.gasto,
          capital_prestamo: this.prestamo.capital,
          monto_incremento: this.montoIncremento
        };
        this.prestamo.gastoCierre = this._prestamo.calcularGastoCierre(data);
      });
  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/prestamos/nuevo/nuevo.component.ts